/* eslint-disable no-console */

if (process.env.NODE_ENV === 'production') {
  const ascii = `
▒─▓██░───▓████████░░▓▓▓▓▓▒▒▒▓██████▓████
█▒░█▒──▒████▒░───░░────░░░░░░▒▒▒▒▓▓▓▓▓██
██▓▓░─▒██▓────────────░░░░▒░░░░░░─░▓▓░▒▓
████─░██▒──░░▒▒▒───░░░░░░▒░░░░░░▓███░░█▓
███▒─██░──░░▒▒▓▓█▒──░░░░▒░────░░███████░
███▒─▓██───────░▓█▒──░░▒───────────▓████
███░██────────────▓▒░░▒──────────────░██
░█▓██─────────────░▓░░░────────────────▓
─▒─▒░─────────────░▓░░───────░▒────────▒
─░░────────▒██░───░█░░──────████▓──░░──░
──░───────▓████▒──▒█░░─────██████▒─░░──░
─░░───────█░████──▒█░░─────█▒█████─░░──▒
─░░──────▓██████──█▓░░────░██████▓─░░──▓
░░░──────▓██████──█▒─░─────██████──░───█
▒─░░──────█████──██░░░░────░████░─────▓█
░░░░───────███──▓█▒─░░░░─────░░──░───▒██
░░░░░──────────▒█▒──░░▒▒░──────░░───▒██▓
░░░░░░────░░░░▓█░───░░▒▒▒▒░──░────░██▓▒▒
░░░░░░░─░░░░▒▓▓─────░░▒▓▒░▒▒░░░░▒▓▓▓▒▒▒▒
░░░░░░░░░▒▒▒▒░──────░▒▒▓▒░░░▒▒▒▒▒▒▒▒▒▒▒▒
░░░─░───────────────░░▒▒▓░░░░░░░░░▒▒▒▒▒▒
░░░░─░───────░─────░░░▒▒▒▒░░░▒░▒▒▒▒▒▒▒▒▒
░░░░░─────────────░░░░▒▒▒▓░░░░▒▒▒▒▒▒▒▒▒▒
░░░░░──────────░─░░░░░▒▒▒▓▒░░░░▒▒▒▒▒▒▒▒▒
░░░░░─░─────────░─░░░░▒▒▒▒▒▒░░▒▒▒▒▒▒▒▒▒▒
░░░░░░░░───────────░░▒▒▒▒▒▒▓▒▒▒▒▒▒▒▒▒▒▒▒
░░░░░─░░░─────────░░▒▒▒▒▒▒▒▒▓▒▒▒▒▒▒▒▒▒▒▒
░░░░░░─░──────────░▒▒▒▒▒▒▒▒▒▓▓▒▒▒▒▒▒▒▒▒▒
░░░░░░░░░────────░░▒▒▒▓▒▒▒▒▒█▓▒▒▒▒▒▒▒▒▒▒
░░░░░░░░──────░▒▒▒▒▓▓▓▒▓▓▓▒▓█▓▒▒▒▒▒▒▒▒▒▒
░░░░░░░──░░░░▒▒▓▓▓▓█▓▓▓▓▓▓▓██▒▒▒▒▒▒▒▒▒▒▒
░░░░░░─░──▒▓████████████████▓▒▒▒▒▒▒▒▒▒▒▒
░░░░░─░─░──░▓██████████████▓▒░▒▒▒▒▒▒▒▒▓▓
░░░░─░─────────░▒▓███████▓▓▒▒▒▒▓▓▓▒▒▓▓█▓
░──────────────────░░░░▒▒▒▒▒▓▒▒▒▒▒▒█▓░█▓
─░░▒▒▓▓▓▓▓▓▓▒░──────░▒▒▒▓▒▒▒▒▒▒▒▒███─▓██
░▓▓▓▒▒▓▓▓▓▓▓███▓▒▒▒▓▓▓▓▒▒░░░▒▒▓▓██▓─▒█▓█
░▓▒▓▓░───░▒▒▒▓▓▓▓▓▓▓▒░──░░▒▓▓████▒─▒██▓█
─▒▒░██▓▒░░░░░░▒▒▒░░──░▒▒▓▓██████░─▒▓█▓██
─░▓░░▓██▓▓▓▒▒▒░░░░▒▒▓▓▓███████▒─░▒▓██▓██
░─▒▓░─▒▓███▓▓▓▓▓▓▓▓▓███████▓▒─░▒▓▓██▓██▓
░░░▓▓░─░▒▓███████████████▓░──▒▒▓███▓████
░░─░█▓░──░▒▓▓████████▓▒░░─░░▒▓▓████████▓
░░░─▒█▓▒░──░░░▒▒▒░░░───░░▒▓▓▓█████████▓▓
░░░░─▒█▓▓▒▒░░░░░░───░▒▒▓▓▓███████████▓▓▓
░░░░░░▒██▓▓▓▓▓▒▒▒▓▓▓▓▓██████████████▓▓▓▓
░░░░░░░░▓████▓█▓█████████████████▓▓▓▓▓▓▓
░░░░░░░░─▒▓███████████████████▓▓▓▓▓▓▒▓▓▓
░░░░░░░░░░░░▒▓███████████▓▓▓▓▓▓▓▓▒▒▒▓▓▓▓
░░░░░▒░░░░░░░░░░▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓▓▓▓▓▓▓
`;

  console.log('%c' + ascii.trim(), 'color: #222; background: #FEC200; ' +
    'padding: 0; line-spacing: 0; line-height: 14px; font-size: 14px;');

  console.log('%cIf you\'ve seen potato head, we probably want to hire you!',
    'color: #FEC200; font-size: 15px;');
  console.log('%cUrban Massage is recruiting engineers - ' +
    'if you\'re interested in working within an exciting high-growth startup, ' +
    'email our CTO on giles@urbanmassage.com', 'color: #FEC200; padding: 5px;');
  console.log('%c*** No recruiters or agencies please ***', 'color: #FEC200;');
  console.log('');
}



// WEBPACK FOOTER //
// ./site/lib/console-message.jsx